var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1783 1.15497C15.4908 1.46752 15.6663 1.89136 15.6663 2.3333C15.6663 2.77524 15.4908 3.19909 15.1783 3.51164L4.68997 14L15.1783 24.4883C15.4819 24.8026 15.6499 25.2236 15.6461 25.6606C15.6423 26.0976 15.467 26.5157 15.158 26.8247C14.849 27.1337 14.431 27.309 13.994 27.3128C13.557 27.3166 13.136 27.1486 12.8216 26.845L1.15497 15.1783C0.842518 14.8658 0.666992 14.4419 0.666992 14C0.666992 13.558 0.842518 13.1342 1.15497 12.8216L12.8216 1.15497C13.1342 0.842518 13.558 0.666992 14 0.666992C14.4419 0.666992 14.8658 0.842518 15.1783 1.15497Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.f9882947aa0e88f9e0f4f5013f41a30e.svg";
export { ForwardRef as ReactComponent };